import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders  } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { JwtHelperService } from '@auth0/angular-jwt';
const jwt = new JwtHelperService();
const HttpUploadOptions = {
  headers: new HttpHeaders({ "Content-Type": "application-json/form-data" })
}
@Injectable({
  providedIn: 'root'
})
export class CommonServiceService {
  private userName$ = new BehaviorSubject<any>({});
  selectedUserName$ = this.userName$.asObservable();

  private emailId$ = new BehaviorSubject<any>({});
  selectedEmailId$ = this.emailId$.asObservable();

  private product$ = new BehaviorSubject<any>({});
  selectedProduct$ = this.product$.asObservable();
  private decodedToken;
  rememberMe: boolean = false;
  constructor(private _http: HttpClient) {  
    this.rememberMe = localStorage.getItem('loginUserDetails') == 'true' ? true : false;
}
  
  setProduct(product: any) {
    this.product$.next(product);
  }
  signUpUser(formData):Observable<any>{
    return this._http.post(`${environment.apiURL}/merchants`,formData);
  }
  signInUser(formData,rememberMe):Observable<any>{
    return this._http.post(`${environment.apiURL}/merchants/login`,formData);
  }
   saveToken(token: any): any {
   // this.decodedToken = jwt.decodeToken(token);
   localStorage.setItem('Access-Token', token);
   // localStorage.setItem('auth_meta', JSON.stringify(this.decodedToken));
     //token;
  }
  saveBusinessRestriction(featuresWhitelisted : any, featuresBlacklisted : any){
    localStorage.setItem('Features-Whitelisted', featuresWhitelisted);
    localStorage.setItem('Features-Blacklisted', featuresBlacklisted);
  }
  updateBusinessDetails(formData):Observable<any>{
    let merchant_id =  JSON.parse(localStorage.getItem('loginUserDetails'));
    return this._http.patch(`${environment.apiURL}/merchants/${merchant_id.merchant_id}/business/info`,formData)
  }
  
  saveBusinessDetails(formData):Observable<any>{
    let merchant_id =  JSON.parse(localStorage.getItem('loginUserDetails'));
    return this._http.put(`${environment.apiURL}/merchants/${merchant_id.merchant_id}/business/info`,formData)
  }
  getBusinessDetails():Observable<any>{
      let merchant_id =  JSON.parse(localStorage.getItem('loginUserDetails'));
      return this._http.get(`${environment.apiURL}/merchants/${merchant_id.merchant_id}/business/info`)
  }
  resetPasswordLink(mailId):Observable<any>{
    return this._http.post(`${environment.apiURL}/merchants/reset-password`,mailId, { responseType: 'text'})
  }
  activateUser(token):Observable<any>{
    return this._http.get(`${environment.apiURL}/merchants/email/verify?token=${token}`);
  }
  setPassword(_data):Observable<any>{
    return this._http.post(`${environment.apiURL}/merchants/set-password`,_data, { responseType: 'text'})
  }
  uploadDocuments(formData):Observable<any>{
    let merchant_id =  JSON.parse(localStorage.getItem('loginUserDetails'));
    return this._http.post(`${environment.apiURL}/merchants/${merchant_id.merchant_id}/business/documents`,formData, { responseType: 'text'})
  }
  getUploadedDocuments(merchant_id):Observable<any>{
    return this._http.get(`${environment.apiURL}/merchants/${merchant_id}/business/documents`);
  }
  setUsername(name:any){
    this.userName$.next(name);
  }
  setEmailId(email:any){
    this.emailId$.next(email);
  }
  getMerchantDetail():Observable<any>{
      let merchant_id =  JSON.parse(localStorage.getItem('loginUserDetails'));
      return this._http.get(`${environment.apiURL}/merchants/${merchant_id.merchant_id}`);
   }
  getApiKey(merchantID){
    return this._http.get<any>(`${environment.apiURL}/merchants/${merchantID}/api-key`);
  }

  getApiKeyOTP(merchantID){
    return this._http.post(`${environment.apiURL}/merchants/${merchantID}/api-key/otp`,null,{ responseType: 'text'})
  }

  verifyApiKeyOTP(merchantID,request){
    return this._http.post(`${environment.apiURL}/merchants/${merchantID}/api-key/otp/verify`,request,{ responseType: 'text'})
  }
}
